<div style="text-align: center">
  <img width="300" alt="OrganizeMED Logo" src="assets/images/om_logo_full_h.svg" />
  <h1>Welcome to {{ title }}!</h1>
</div>
<h3>Please keep your API Key handy to help you start:</h3>
<div>Inegration with OrganizeMED MESH: API Integration documentation ... coming soon.</div>

<div class="corner-ribbon bottom-left sticky blue shadow" *ngIf="devEnvironment">DEV</div>
<div class="corner-ribbon bottom-right sticky red shadow" *ngIf="demoEnvironment">DEMO</div>
